/**
 * Functionality for the Route Simulator Entrance component.
 * Handles swapping of origin and destination input fields.
 *
 * @module feature/RouteSimulator
 */

/**
 * Enables swap functionality for the route simulator entrance form.
 *
 * @memberof module:feature/RouteSimulator
 * @version 1.0.0
 */
class RouteSimulatorEntrance {
    /**
     * Upgrades DOM element.
     * @param {DOMElement} element DOM element to upgrade.
     */
    constructor(element) {
        this.element = element[0];
        this.swapBtn = null;
        this.from = null;
        this.to = null;
        this.directLink = null;
    }

    /**
     * Configures after load.
     */
    init() {
        this.swapBtn = this.element.querySelector('.js-swap-route');
        this.from = this.element.querySelector('input[name="from"]');
        this.to = this.element.querySelector('input[name="to"]');
        this.directLink = this.element.querySelector('.route-simulator-entrance__direct-link');

        if (this.swapBtn && this.from && this.to) {
            this.swapBtn.addEventListener('click', () => this.swap());
        }

        if (this.directLink) {
            this.directLink.addEventListener('click', () => {
                // Update href synchronously before the browser follows the link.
                // target="_blank" on the anchor handles opening in a new tab.
                this.directLink.href = this.buildDirectLink(this.directLink);
            });
        }
    }

    /**
     * Swaps the values of the from and to input fields.
     */
    swap() {
        const temp = this.from.value;
        this.from.value = this.to.value;
        this.to.value = temp;
    }

    /**
     * Builds the direct-link URL by appending serie, from and to
     * as query-string parameters.
     *
     * @param {HTMLAnchorElement} el - The direct-link anchor element.
     * @returns {string} The fully built URL.
     */
    buildDirectLink(el) {
        const baseUrl = el.dataset.baseUrl;
        const series = el.dataset.series;

        const params = new URLSearchParams();
        params.set('series', series);

        const fromVal = this.from ? this.from.value.trim() : '';
        const toVal = this.to ? this.to.value.trim() : '';

        if (fromVal) params.set('from', fromVal);
        if (toVal) params.set('to', toVal);

        return `${baseUrl}?${params.toString()}`;
    }
}

// register to Component Handler
window.ComponentHandler.register({
    constructor: RouteSimulatorEntrance,
    classAsString: 'RouteSimulatorEntrance',
    cssClass: 'js-route-entrance-form'
});

export default RouteSimulatorEntrance;
